const TILT_SELECTOR = '[data-tilt]';
const TILT_MIN_WIDTH = 1034;

let tiltLoadPromise = null;

function canInitTilt() {
  return window.innerWidth >= TILT_MIN_WIDTH;
}

function addTiltElements(elements, value) {
  if (!(value instanceof Element)) {
    return;
  }

  if (value.matches(TILT_SELECTOR)) {
    elements.add(value);
  }

  value.querySelectorAll(TILT_SELECTOR).forEach((element) => {
    elements.add(element);
  });
}

function resolveTiltElements(target = document) {
  const elements = new Set();

  if (typeof target === 'string') {
    document.querySelectorAll(target).forEach((element) => {
      addTiltElements(elements, element);
    });

    return [...elements];
  }

  if (
    target instanceof Element ||
    target instanceof window.Document ||
    target instanceof window.DocumentFragment
  ) {
    if (target instanceof Element) {
      addTiltElements(elements, target);
    } else {
      target.querySelectorAll(TILT_SELECTOR).forEach((element) => {
        elements.add(element);
      });
    }

    return [...elements];
  }

  if (
    target instanceof window.NodeList ||
    target instanceof window.HTMLCollection ||
    Array.isArray(target)
  ) {
    Array.from(target).forEach((element) => {
      addTiltElements(elements, element);
    });
  }

  return [...elements];
}

function loadTiltScript() {
  if (!canInitTilt()) {
    return Promise.resolve(null);
  }

  if (window.VanillaTilt) {
    return Promise.resolve(window.VanillaTilt);
  }

  if (tiltLoadPromise) {
    return tiltLoadPromise;
  }

  tiltLoadPromise = import('vanilla-tilt/dist/vanilla-tilt.js')
    .then((module) => window.VanillaTilt || module.default || null)
    .catch((error) => {
      tiltLoadPromise = null;
      throw error;
    });

  return tiltLoadPromise;
}

export async function initDataTilt(target = document) {
  const elements = resolveTiltElements(target);

  if (!elements.length || !canInitTilt()) {
    return [];
  }

  const VanillaTilt = await loadTiltScript();
  if (!VanillaTilt) {
    return [];
  }

  const freshElements = elements.filter((element) => !element.vanillaTilt);
  if (!freshElements.length) {
    return [];
  }

  VanillaTilt.init(freshElements);
  return freshElements;
}

function runInitialDataTilt() {
  initDataTilt().catch((error) => {
    console.error(error);
  });
}

window.initDataTilt = initDataTilt;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitialDataTilt, { once: true });
} else {
  runInitialDataTilt();
}
